import { gql } from '@apollo/client';

export const GET_LEGAL_SETUP_CONFIGS = gql`
  query getLegalSetupConfigs {
    liveOps {
      legalSetupConfigs {
        id
        adultAge
        cmpAllowedAge
        attAllowedAge
        updatedAt
      }
      legalSetupRegions {
        id
        countries
      }
      legalSetupBlockModeCountries
    }
  }
`;

export const SET_LEGAL_SETUP_CONFIG = gql`
  mutation setLegalSetupConfig($input: LegalSetupConfigInput!) {
    setLegalSetupConfig(input: $input) {
      id
      adultAge
      cmpAllowedAge
      attAllowedAge
      updatedAt
    }
  }
`;

export const DELETE_LEGAL_SETUP_CONFIG = gql`
  mutation deleteLegalSetupConfig($id: ID!) {
    deleteLegalSetupConfig(id: $id)
  }
`;

export const GET_STORE_AGE_VALIDATOR_CONFIG = gql`
  query getStoreAgeValidatorConfig {
    liveOps {
      storeAgeValidatorConfig {
        enabled
        platform
        versionConditions {
          op
          value
        }
        countries
        kidModeNoticeEnabled
        kidModeNoticeTexts
      }
    }
  }
`;

export const UPDATE_STORE_AGE_VALIDATOR_CONFIG = gql`
  mutation updateStoreAgeValidatorConfig($input: StoreAgeValidatorConfigInput!) {
    updateStoreAgeValidatorConfig(input: $input) {
      enabled
      platform
      versionConditions {
        op
        value
      }
      countries
      kidModeNoticeEnabled
      kidModeNoticeTexts
    }
  }
`;

export const GET_US_OPT_OUT_CONFIG = gql`
  query getUsOptOutConfig {
    liveOps {
      usOptOutConfig {
        enabled
        platform
        versionConditions {
          op
          value
        }
        noticeId
      }
    }
  }
`;

export const UPDATE_US_OPT_OUT_CONFIG = gql`
  mutation updateUsOptOutConfig($input: UsOptOutConfigInput!) {
    updateUsOptOutConfig(input: $input) {
      enabled
      platform
      versionConditions {
        op
        value
      }
      noticeId
    }
  }
`;
